<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生管理</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>工讀生清單</span></li>
          <li><span>設定勞保/勞退</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body" align="right">
              <div align="right">
                <table class="table table-no-more table-bordered table-striped mb-none">
                  <thead>
                    <tr>
                      <th class="text-center" width="6%">筆數</th>
                      <th class="text-center" width="6%">服務單位</th>
                      <th class="text-center" width="6%">學號</th>
                      <th class="text-center" width="6%">學生姓名</th>
                      <th class="text-center" width="10%">預計{{month}}月份上班總時數</th>
                      <th class="text-center" width="30%">設定日保/月保(試算)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="筆數" class="text-center">{{index + 1}}</td>
                      <td data-title="服務單位" class="text-center">{{item.deptName}}</td>
                      <td data-title="學號" class="text-center">{{item.studentId}}</td>
                      <td data-title="學生姓名" class="text-center">{{item.studentName}}</td>
                      <td data-title="本月上班總時數" class="text-center">{{item.totalHours}}</td>
                      <td data-title="設定日保/月保" class="text-left">
                        <div v-for="(cost, ci) in item.laborCostList" :key="ci">
                          <label style="font-size: 14px; padding: 6px; margin: 0;">
                            <input type="radio" :name="item.workstudyId" :value="cost.costType" :checked="item.selectCostType == cost.costType" @change.prevent="costTypeChange">
                            ({{cost.costType}}) 勞保費:{{cost.insuranceCost}}, 勞退費:{{cost.pensionCost}}, 學生自付額:{{cost.selfCost}}, 工讀薪資:{{item.salary}}
                          </label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table><br>
                <div class="row datatables-footer">
                  <div class="col-sm-12">
                    <div align="center">
                      <a href="#" @click.prevent="submit" class="btn-upload btn" style="background-color:#8C0044; border-color:#8C0044; color:#FFF;">儲存</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      costList: []
    };
  },
  computed: {
    year() {
      return this.$route.params.year;
    },
    month() {
      return this.$route.params.month;
    }
  },
  mounted() {
    this.$http.get("/api/workstudy/cost/" + this.year + "/" + this.month).then(a => {
      this.list = a.body;
      this.list.forEach(item => {
        if (item.selectCostType) {
          let selectCost = item.laborCostList.filter(c => {
            return c.costType == item.selectCostType;
          })[0];
          this.costList.push({
            workstudyId: item.workstudyId,
            costType: item.selectCostType,
            laborInsurance: selectCost.insuranceCost,
            laborPension: selectCost.pensionCost,
            selfCost: selectCost.selfCost,
            salary: item.salary
          });
        }
      });
    });
  },
  methods: {
    costTypeChange(e) {
      let costType = $(e.target).val();
      let workstudyId = $(e.target).attr("name");
      // 從List刪除
      let oldCost = this.costList.filter(a => {
        return a.workstudyId == workstudyId;
      })[0];
      if (oldCost) {
        let index = this.costList.indexOf(oldCost);
        this.costList.splice(index, 1);
      }
      // 加入List
      let item = this.list.filter(a => {
        return a.workstudyId == workstudyId;
      })[0];
      let selectCost = item.laborCostList.filter(a => {
        return a.costType == costType;
      })[0];
      let cost = {
        workstudyId: workstudyId,
        costType: costType,
        laborInsurance: selectCost.insuranceCost,
        laborPension: selectCost.pensionCost,
        selfCost: selectCost.selfCost,
        salary: item.salary
      };
      this.costList.push(cost);
    },
    submit() {
      if (this.costList.length == 0) {
        alert("尚未選取任何資料。");
        return false;
      }
      this.$http.post("/api/workstudy/cost/" + this.year + "/" + this.month, this.costList).then(a => {
        if (a.body.status) {
          alert("儲存成功");
          this.$router.push("/workstudy");
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    }
  }
};
</script>

<style>
</style>